export enum TimelineParty {
    VetValue = 0,
    Seller = 1,
    Buyer = 2,
    Broker = 3,
    SellerAndBuyer = 4,
}

export const TimelineParties = [
    { id: TimelineParty.VetValue, name: 'VetValue' },
    { id: TimelineParty.Seller, name: 'Seller' },
    { id: TimelineParty.Buyer, name: 'Buyer' },
    { id: TimelineParty.Broker, name: 'Advisor' },
    { id: TimelineParty.SellerAndBuyer, name: 'Seller / Buyer' },
];

export const TimelinePartyColors = [
    {
        id: TimelineParty.VetValue,
        color: '#cc8400',
        backgroundColor: '#ffe0b3',
        activeColor: '#ffe0b3',
        activeBackgroundColor: '#cc8400',
    },
    {
        id: TimelineParty.Seller,
        color: '#666630',
        backgroundColor: '#fcffa8',
        activeColor: '#fcffa8',
        activeBackgroundColor: '#808047',
    },
    {
        id: TimelineParty.Buyer,
        color: '#1b4f8a',
        backgroundColor: '#a8d2ff',
        activeColor: '#a8d2ff',
        activeBackgroundColor: '#1b4f8a',
    },
    {
        id: TimelineParty.Broker,
        color: '#22577A',
        backgroundColor: '#A2D5F2',
        activeColor: '#A2D5F2',
        activeBackgroundColor: '#22577A',
    },
    {
        id: TimelineParty.SellerAndBuyer,
        color: '#336640',
        backgroundColor: '#a1ffaf',
        activeColor: '#a1ffaf',
        activeBackgroundColor: '#336640',
    },
];
